import * as THREE from 'three';
import { G, M, TINT, HP, glowMat, mesh, bevel, plate, mergeBones, stages, boneG } from './kit';
/* ============================================================
   KRONE 冠冕 —— BOSS・複合環
   ============================================================

   剪影：10 單位大環＋八具掛載
   階段：'P1 水平自轉・八具輪流開火','P2 傾斜 40°・半數關閉','P3 立起・變成滾動的輪'

   由 `tools/port-bosses.mjs` 從 `enemy_sample_ani.html` 機械移植，
   **不要手改這個檔**：要改造型請改原型再重跑移植器，否則 1:1 就斷了。
   驗證：`node tools/port-bosses.mjs --check`。
   ⚠️ 比對只守得住數字與字串，**動畫對不對只能實看**（圖鑑的開發模式）。 */


/* ── BOSS-11 KRONE 冠冕 ── 複合式：一個 10 單位寬的環，掛 8 個可個別破壞的模組。
   P1 水平自轉，八個模組輪流開火 → 打模組還是打中軸是你的選擇。
   P2 環傾斜 40°，半數模組關閉 —— 傾斜之後低的那半邊終於打得到。
   P3 環整個立起來，變成一個 10 單位直徑的輪，往你身上滾。 */
export function buildKrone(){
  var GLA = glowMat(TINT.amb.hex, 2.2), GLV = glowMat(TINT.vio.hex, 2.4);
  var root = new THREE.Group(), pods = [], i;
  var ring = boneG(root, 0, 4.00, 0);
  ring.add(mesh(G.tor, M.armor, [9.80,9.80,0.80], [0,0,0], [HP,0,0]));
  ring.add(mesh(G.tor, M.trim,  [10.4,10.4,0.34], [0,0,0], [HP,0,0]));
  ring.add(mesh(G.tor, M.trim,  [9.20,9.20,0.34], [0,0,0], [HP,0,0]));
  for (i = 0; i < 8; i++){
    var a = i*Math.PI * 2/8;
    var pd = boneG(ring, Math.sin(a)*4.90, 0, Math.cos(a)*4.90);
    pd.rotation.y = a;
    pd.add(bevel(M.dark,  1.10, 1.00, 1.20, [0,0,0]));
    pd.add(plate(M.armor, 1.24, 0.44, 0.70, [0, 0.44, 0.30], -0.34));
    pd.add(mesh(G.cyl, M.armor, [0.34,1.40,0.34], [0,-0.10,0.80], [HP,0,0]));
    var mz = mesh(G.tor, GLA, [0.60,0.60,0.55], [0,-0.10,1.52]);
    mz.userData.noMerge = 1; pd.add(mz);
    pods.push(pd);
  }
  /* 中軸吊艙：環立起來之後它會變成輪心 */
  var hub = boneG(ring, 0, 0, 0);
  hub.add(bevel(M.dark,  2.00, 1.60, 2.00, [0,0,0]));
  hub.add(plate(M.armor, 2.20, 0.60, 1.10, [0, 0.52, 0.50], -0.34));
  for (i = 0; i < 4; i++){
    var b = i*Math.PI * 2/4 + 0.78;
    hub.add(mesh(G.box, M.armor, [0.34,0.30,3.60],
      [Math.sin(b)*1.90, 0, Math.cos(b)*1.90], [0,-b,0]));
  }
  var cm = mesh(G.oct, GLV, [1.30,1.30,1.30], [0,0,0]);
  cm.userData.noMerge = 1; hub.add(cm);
  root.userData.rig = {ring:ring, pods:pods, hub:hub, cm:cm, GLA:GLA, GLV:GLV};
  return mergeBones(root);
}
export function updKrone(rig, o, dt){
  stages(rig, o, dt, 1.7);
  var s1 = rig.s1, s2 = rig.s2, i;
  rig.ring.rotation.x = 0.70*s1 + (HP - 0.70)*s2;    // 水平 → 40° → 直立
  rig.ring.rotation.y += dt*(0.40 + 0.9*s1 + 2.6*s2);
  rig.ring.position.y = 4.00 - 0.30*s1 + 1.10*s2 + 0.16*Math.sin(o.t*0.9);
  for (i = 0; i < 8; i++){
    var on = (s2 > 0.5) ? true : (s1 > 0.5 ? (i % 2 === 0) : true);
    rig.pods[i].visible = on;
    rig.pods[i].rotation.x = -o.tel*0.30 + o.atk*0.42;
  }
  rig.hub.rotation.z += dt*(0.6 + 3.0*s2);
  rig.cm.scale.setScalar(1 + 0.14*Math.sin(o.t*2.8) + 0.9*o.tel + 0.5*s2);
  rig.GLA.emissiveIntensity = 2.2 + 3.0*o.tel + 6*o.atk*(1-o.atk);
  rig.GLV.emissiveIntensity = 1.0 + 1.6*s1 + 2.8*s2;
}